import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Sidebar from './components/layout/Sidebar';
import Members from './pages/reports/Members';
import Dues from './pages/reports/Dues';
import Gradings from './pages/reports/Gradings';
import Eligibility from './pages/reports/Eligibility';
import Registration from './pages/reports/Registration';

const ProtectedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ display: 'flex', backgroundColor: '#0a0a0a', minHeight: '100vh' }}>
      <Sidebar />
      <main
        className="nask-main-content"
        style={{ marginLeft: '240px', flex: 1, minHeight: '100vh' }}
      >
        {children}
      </main>
    </div>
  );
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedLayout>
                <Dashboard />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reports/members"
            element={
              <ProtectedLayout>
                <Members />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reports/memberships"
            element={
              <ProtectedLayout>
                <Dues />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reports/gradings"
            element={
              <ProtectedLayout>
                <Gradings />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reports/eligibility"
            element={
              <ProtectedLayout>
                <Eligibility />
              </ProtectedLayout>
            }
          />
          <Route
            path="/reports/registration"
            element={
              <ProtectedLayout>
                <Registration />
              </ProtectedLayout>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;